import React from 'react';

export type LevelSelectProps = {
  value?: 0 | 1 | 2;
  onChange: (value: 0 | 1 | 2) => void;
  title?: string;
  ariaLabel?: string;
};

/**
 * LevelSelect
 * Extracted difficulty level selector (range 0..2) with labels.
 * Uses global CSS classes defined in CoursesFilter.css (cf-*) for styling.
 */
const LevelSelect: React.FC<LevelSelectProps> = ({ value = 1, onChange, title = 'Difficulty level', ariaLabel = 'Difficulty level' }) => {
  return (
    <div className="cf-section">
      <div className="cf-section-title">{title}</div>
      <div className="cf-diff">
        <input
          className="cf-range"
          type="range"
          min={0}
          max={2}
          step={1}
          value={value}
          onChange={(e) => onChange(Number(e.target.value) as 0 | 1 | 2)}
          style={{
            // @ts-ignore custom CSS var for gradient stop
            '--percent': `${(value / 2) * 100}%`
          } as React.CSSProperties}
          aria-label={ariaLabel}
        />
        <div className="cf-diff-labels">
          <span className={value === 0 ? 'active' : ''}>Beginner</span>
          <span className={value === 1 ? 'active' : ''}>Intermediate</span>
          <span className={value === 2 ? 'active' : ''}>Advanced</span>
        </div>
      </div>
    </div>
  );
};

export default LevelSelect;
